<template>
  <ul class="navigation-tabs">
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="classes(index)"
    >
      <span
        :is="is(item)"
        :to="item.path"
        class="navigation-tabs-item-link"
        @click="click(index)"
      >
        <font-awesome-icon
          v-if="item.icon"
          :icon="item.icon"
          class="navigation-tabs-icon"
        />

        {{ item.label }}

        <span
          v-if="item.count"
          class="navigation-tabs-count"
        >
          {{ item.count }}
        </span>
      </span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'NavigationTabs',
    props: {
      items: {
        type: Array,
        default() {
          return [];
        },
      },
      active: {
        type: Number,
        default: null,
      },
    },
    methods: {
      classes(index) {
        const { active } = this;
        const classes = ['navigation-tabs-item'];

        if (typeof active === 'number' && active === index) {
          classes.push('navigation-tabs-item-active');
        }

        return classes;
      },
      is(item) {
        if (item.path) {
          return 'router-link';
        }

        return 'span';
      },
      click(index) {
        this.$emit('click', index);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  $height: 2px;

  .navigation-tabs {
    align-items: stretch;
    background-color: $white;
    border-bottom: $height solid $gray-dark;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style: none;
    user-select: none;

    @media all and (min-width: $breakpoint-desktop) {
      background-color: transparent;
      border-bottom-width: 1px;
      justify-content: center;
    }
  }

  .navigation-tabs-icon {
    margin-right: 0.5em;
  }

  .navigation-tabs-count {
    background-color: $red;
    border-radius: $button-smallest * 0.5;
    color: $white;
    display: block;
    line-height: $button-smallest;
    margin-left: 0.5em;
    min-width: $button-smallest;
    padding: 0 $gutter-smaller;
  }

  .navigation-tabs-item {
    align-items: stretch;
    display: flex;
    height: $button;
    flex: 1;
    justify-content: stretch;
    margin-bottom: -$height;
    text-align: center;

    @media all and (min-width: $breakpoint-desktop) {
      height: $gutter-smallest + $button + $gutter-smallest;
      margin-bottom: -1px;
    }
  }

  .navigation-tabs-item-link {
    align-items: center;
    border-bottom: $height solid $gray-dark;
    box-shadow: none;
    color: $gray;
    cursor: pointer;
    display: flex;
    flex: 1;
    font-weight: $bold;
    justify-content: center;
    outline: none;
    padding: 0 $gutter-big;
    transition: border-bottom-color 0.1s, color 0.1s, box-shadow 0.1s;

    @media all and (min-width: $breakpoint-desktop) {
      border-bottom-width: 1px;
      padding: 0 $gutter-biggest;
    }

    .navigation-tabs-item-active &,
    &.router-link-exact-active {
      border-bottom-color: $green;
      color: $black;

      @media all and (min-width: $breakpoint-desktop) {
        $top: inset 0 $height $green;
        $right: inset -2px 0 0 -1px $gray-dark;
        $left: inset 2px 0 0 -1px $gray-dark;

        background-color: $white;
        border-bottom-color: $white;
        box-shadow: $top, $right, $left;

        .navigation-tabs-item:first-child & {
          box-shadow: $top, $right;
        }

        .navigation-tabs-item:last-child & {
          box-shadow: $top, $left;
        }
      }
    }
  }
</style>
